"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TitleAgreement = require("./TitleAgreement");
Object.keys(_TitleAgreement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TitleAgreement[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TitleAgreement[key];
    }
  });
});